import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAward, FiTrendingUp, FiUsers, FiBookOpen } = FiIcons;

const AuthoritySection = () => {
  return (
    <section className="authority-section py-20 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            From Multi-Crore Recurring Income to <span className="text-blue-600">Helping You Do the Same</span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div 
            className="story-content"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="bg-white p-8 rounded-2xl shadow-xl border-l-4 border-blue-600">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Meet Abdul Hakkim A</h3>
              <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
                <p>
                  Abdul has been running multiple software companies for the last 3 years, generating multi-crore recurring income every year from software subscriptions.
                </p>
                <p>
                  Unlike others who teach theory, Abdul has real skin in the game. His software companies serve thousands of clients across India, providing consistent, predictable revenue month after month.
                </p>
                <p className="font-semibold text-blue-600">
                  Now he wants to help a small, serious group from his community replicate this exact model.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div 
            className="credibility-points"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="space-y-6">
              <div className="credibility-card bg-white p-6 rounded-xl shadow-lg border border-gray-200">
                <div className="flex items-center space-x-4">
                  <SafeIcon icon={FiAward} className="text-3xl text-yellow-500" />
                  <div>
                    <h4 className="font-bold text-gray-900">Built and scaled multiple SaaS products</h4>
                    <p className="text-gray-600">Real experience, not just theory</p>
                  </div>
                </div>
              </div>

              <div className="credibility-card bg-white p-6 rounded-xl shadow-lg border border-gray-200">
                <div className="flex items-center space-x-4">
                  <SafeIcon icon={FiTrendingUp} className="text-3xl text-green-500" />
                  <div>
                    <h4 className="font-bold text-gray-900">Helped coaches & businesses automate and grow using AI</h4>
                    <p className="text-gray-600">Proven track record of client success</p>
                  </div>
                </div>
              </div>

              <div className="credibility-card bg-white p-6 rounded-xl shadow-lg border border-gray-200">
                <div className="flex items-center space-x-4">
                  <SafeIcon icon={FiUsers} className="text-3xl text-blue-500" />
                  <div>
                    <h4 className="font-bold text-gray-900">Generates multi-crore recurring revenue annually</h4>
                    <p className="text-gray-600">From his own software companies</p>
                  </div>
                </div>
              </div>

              <div className="credibility-card bg-white p-6 rounded-xl shadow-lg border border-gray-200">
                <div className="flex items-center space-x-4">
                  <SafeIcon icon={FiBookOpen} className="text-3xl text-purple-500" />
                  <div>
                    <h4 className="font-bold text-gray-900">Known for simple, implementation-focused teaching</h4>
                    <p className="text-gray-600">No fluff, just actionable strategies</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AuthoritySection;